import { SimpleArrayList } from '../simpleArrayList';

/**
 * Chemistry data table: Atomic Number, Symbol, Czech Name, English Name, Latin Name.
 * Port of C# EduFrame.OrderGen.Generators.Chemie.
 */
export const ChemistryElements: string[][] = [
  ['1', 'H', 'Vodík', 'Hydrogen', 'Hydrogenium'],
  ['2', 'He', 'Helium', 'Helium', 'Helium'],
  ['3', 'Li', 'Lithium', 'Lithium', 'Lithium'],
  ['4', 'Be', 'Beryllium', 'Beryllium', 'Beryllium'],
  ['5', 'B', 'Bor', 'Boron', 'Borum'],
  ['6', 'C', 'Uhlík', 'Carbon', 'Carbonium'],
  ['7', 'N', 'Dusík', 'Nitrogen', 'Nitrogenium'],
  ['8', 'O', 'Kyslík', 'Oxygen', 'Oxygenium'],
  ['9', 'F', 'Fluor', 'Fluorine', 'Fluorum'],
  ['10', 'Ne', 'Neon', 'Neon', 'Neon'],
  ['11', 'Na', 'Sodík', 'Sodium', 'Natrium'],
  ['12', 'Mg', 'Hořčík', 'Magnesium', 'Magnesium'],
  ['13', 'Al', 'Hliník', 'Aluminium', 'Aluminium'],
  ['14', 'Si', 'Křemík', 'Silicon', 'Silicium'],
  ['15', 'P', 'Fosfor', 'Phosphorus', 'Phosphorus'],
  ['16', 'S', 'Síra', 'Sulfur', 'Sulphur'],
  ['17', 'Cl', 'Chlor', 'Chlorine', 'Chlorum'],
  ['18', 'Ar', 'Argon', 'Argon', 'Argon'],
  ['19', 'K', 'Draslík', 'Potassium', 'Kalium'],
  ['20', 'Ca', 'Vápník', 'Calcium', 'Calcium'],
  ['21', 'Sc', 'Skandium', 'Scandium', 'Scandium'],
  ['22', 'Ti', 'Titan', 'Titanium', 'Titanium'],
  ['23', 'V', 'Vanad', 'Vanadium', 'Vanadium'],
  ['24', 'Cr', 'Chrom', 'Chromium', 'Chromium'],
  ['25', 'Mn', 'Mangan', 'Manganese', 'Manganum'],
  ['26', 'Fe', 'Železo', 'Iron', 'Ferrum'],
  ['27', 'Co', 'Kobalt', 'Cobalt', 'Cobaltum'],
  ['28', 'Ni', 'Nikl', 'Nickel', 'Niccolum'],
  ['29', 'Cu', 'Měď', 'Copper', 'Cuprum'],
  ['30', 'Zn', 'Zinek', 'Zinc', 'Zincum'],
  ['31', 'Ga', 'Gallium', 'Gallium', 'Gallium'],
  ['32', 'Ge', 'Germanium', 'Germanium', 'Germanium'],
  ['33', 'As', 'Arsen', 'Arsenic', 'Arsenicum'],
  ['34', 'Se', 'Selen', 'Selenium', 'Selenium'],
  ['35', 'Br', 'Brom', 'Bromine', 'Bromum'],
  ['36', 'Kr', 'Krypton', 'Krypton', 'Krypton'],
  ['37', 'Rb', 'Rubidium', 'Rubidium', 'Rubidium'],
  ['38', 'Sr', 'Stroncium', 'Strontium', 'Strontium'],
  ['39', 'Y', 'Yttrium', 'Yttrium', 'Yttrium'],
  ['40', 'Zr', 'Zirkonium', 'Zirconium', 'Zirconium'],
  ['41', 'Nb', 'Niob', 'Niobium', 'Niobium'],
  ['42', 'Mo', 'Molybden', 'Molybdenum', 'Molybdaenum'],
  ['43', 'Tc', 'Technecium', 'Technetium', 'Technetium'],
  ['44', 'Ru', 'Ruthenium', 'Ruthenium', 'Ruthenium'],
  ['45', 'Rh', 'Rhodium', 'Rhodium', 'Rhodium'],
  ['46', 'Pd', 'Palladium', 'Palladium', 'Palladium'],
  ['47', 'Ag', 'Stříbro', 'Silver', 'Argentum'],
  ['48', 'Cd', 'Kadmium', 'Cadmium', 'Cadmium'],
  ['49', 'In', 'Indium', 'Indium', 'Indium'],
  ['50', 'Sn', 'Cín', 'Tin', 'Stannum'],
  ['51', 'Sb', 'Antimon', 'Antimony', 'Stibium'],
  ['52', 'Te', 'Tellur', 'Tellurium', 'Tellurium'],
  ['53', 'I', 'Jod', 'Iodine', 'Iodium'],
  ['54', 'Xe', 'Xenon', 'Xenon', 'Xenon'],
  ['55', 'Cs', 'Cesium', 'Cesium', 'Caesium'],
  ['56', 'Ba', 'Baryum', 'Barium', 'Barium'],
  ['57', 'La', 'Lanthan', 'Lanthanum', 'Lanthanum'],
  ['58', 'Ce', 'Cer', 'Cerium', 'Cerium'],
  ['59', 'Pr', 'Praseodym', 'Praseodymium', 'Praseodymium'],
  ['60', 'Nd', 'Neodym', 'Neodymium', 'Neodymium'],
  ['61', 'Pm', 'Promethium', 'Promethium', 'Promethium'],
  ['62', 'Sm', 'Samarium', 'Samarium', 'Samarium'],
  ['63', 'Eu', 'Europium', 'Europium', 'Europium'],
  ['64', 'Gd', 'Gadolinium', 'Gadolinium', 'Gadolinium'],
  ['65', 'Tb', 'Terbium', 'Terbium', 'Terbium'],
  ['66', 'Dy', 'Dysprosium', 'Dysprosium', 'Dysprosium'],
  ['67', 'Ho', 'Holmium', 'Holmium', 'Holmium'],
  ['68', 'Er', 'Erbium', 'Erbium', 'Erbium'],
  ['69', 'Tm', 'Thulium', 'Thulium', 'Thulium'],
  ['70', 'Yb', 'Ytterbium', 'Ytterbium', 'Ytterbium'],
  ['71', 'Lu', 'Lutecium', 'Lutetium', 'Lutetium'],
  ['72', 'Hf', 'Hafnium', 'Hafnium', 'Hafnium'],
  ['73', 'Ta', 'Tantal', 'Tantalum', 'Tantalum'],
  ['74', 'W', 'Wolfram', 'Tungsten', 'Wolframium'],
  ['75', 'Re', 'Rhenium', 'Rhenium', 'Rhenium'],
  ['76', 'Os', 'Osmium', 'Osmium', 'Osmium'],
  ['77', 'Ir', 'Iridium', 'Iridium', 'Iridium'],
  ['78', 'Pt', 'Platina', 'Platinum', 'Platinum'],
  ['79', 'Au', 'Zlato', 'Gold', 'Aurum'],
  ['80', 'Hg', 'Rtuť', 'Mercury', 'Hydrargyrum'],
  ['81', 'Tl', 'Thallium', 'Thallium', 'Thallium'],
  ['82', 'Pb', 'Olovo', 'Lead', 'Plumbum'],
  ['83', 'Bi', 'Bismut', 'Bismuth', 'Bismuthum'],
  ['84', 'Po', 'Polonium', 'Polonium', 'Polonium'],
  ['85', 'At', 'Astat', 'Astatine', 'Astatium'],
  ['86', 'Rn', 'Radon', 'Radon', 'Radon'],
  ['87', 'Fr', 'Francium', 'Francium', 'Francium'],
  ['88', 'Ra', 'Radium', 'Radium', 'Radium'],
  ['89', 'Ac', 'Aktinium', 'Actinium', 'Actinium'],
  ['90', 'Th', 'Thorium', 'Thorium', 'Thorium'],
  ['91', 'Pa', 'Protaktinium', 'Protactinium', 'Protactinium'],
  ['92', 'U', 'Uran', 'Uranium', 'Uranium'],
  ['93', 'Np', 'Neptunium', 'Neptunium', 'Neptunium'],
  ['94', 'Pu', 'Plutonium', 'Plutonium', 'Plutonium'],
  ['95', 'Am', 'Americium', 'Americium', 'Americium'],
  ['96', 'Cm', 'Curium', 'Curium', 'Curium'],
  ['97', 'Bk', 'Berkelium', 'Berkelium', 'Berkelium'],
  ['98', 'Cf', 'Kalifornium', 'Californium', 'Californium'],
  ['99', 'Es', 'Einsteinium', 'Einsteinium', 'Einsteinium'],
  ['100', 'Fm', 'Fermium', 'Fermium', 'Fermium'],
  ['101', 'Md', 'Mendelevium', 'Mendelevium', 'Mendelevium'],
  ['102', 'No', 'Nobelium', 'Nobelium', 'Nobelium'],
  ['103', 'Lr', 'Lawrencium', 'Lawrencium', 'Lawrencium'],
  ['104', 'Rf', 'Rutherfordium', 'Rutherfordium', 'Rutherfordium'],
  ['105', 'Db', 'Dubnium', 'Dubnium', 'Dubnium'],
  ['106', 'Sg', 'Seaborgium', 'Seaborgium', 'Seaborgium'],
  ['107', 'Bh', 'Bohrium', 'Bohrium', 'Bohrium'],
  ['108', 'Hs', 'Hassium', 'Hassium', 'Hassium'],
  ['109', 'Mt', 'Meitnerium', 'Meitnerium', 'Meitnerium'],
  ['110', 'Ds', 'Darmstadtium', 'Darmstadtium', 'Darmstadtium'],
  ['111', 'Rg', 'Roentgenium', 'Roentgenium', 'Roentgenium'],
  ['112', 'Cn', 'Kopernicium', 'Copernicium', 'Copernicium'],
  ['113', 'Nh', 'Nihonium', 'Nihonium', 'Nihonium'],
  ['114', 'Fl', 'Flerovium', 'Flerovium', 'Flerovium'],
  ['115', 'Mc', 'Moscovium', 'Moscovium', 'Moscovium'],
  ['116', 'Lv', 'Livermorium', 'Livermorium', 'Livermorium'],
  ['117', 'Ts', 'Tennessine', 'Tennessine', 'Tennessium'],
  ['118', 'Og', 'Oganesson', 'Oganesson', 'Oganesson'],
];

export class GenList_Chemistry__Elements_Number_Name__CS extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[0], (i) => i[2]);
  }
}

export class GenList_Chemistry__Elements_Number_Name__EN extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[0], (i) => i[3]);
  }
}

export class GenList_Chemistry__Elements_Number_Name__LA extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[0], (i) => i[4]);
  }
}

export class GenList_Chemistry__Elements_Number_Symbol__CS extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[0], (i) => i[1]);
  }
}

export class GenList_Chemistry__Elements_Name_Name__LA extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[2], (i) => i[4]);
  }
}

export class GenList_Chemistry__Elements_Symbol_Name__CS extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[1], (i) => i[2]);
  }
}

export class GenList_Chemistry__Elements_Symbol_Name__LA extends SimpleArrayList<string[]> {
  constructor() {
    super(ChemistryElements, (i) => i[1], (i) => i[4]);
  }
}
